import { reactive, toRefs, onMounted, getCurrentInstance } from "vue";
import Cookie from "@/utils/cache.js";
import { ElMessage } from "element-plus";
import globalStore from "@/store/global.js";

let data = reactive({
  colorStandards: ["DE cmc", "CMC DE", "DE2000"],
  ColorStandards: [
    { label: "CIE DE ", value: 0 },
    { label: "CMC DE (2:1)", value: 1 },
    { label: "DE2000", value: 2 },
  ],
  // 31 点值
  ThirtyOneList: [
    360, 370, 380, 390, 400, 410, 420, 430, 440, 450, 460, 470, 480, 490, 500,
    510, 520, 530, 540, 550, 560, 570, 580, 590, 600, 610, 620, 630, 640, 650,
    660, 670, 680, 690, 700,
  ],
  // 优先级
  //  综合 Default = 0
  //  色差-跳灯-牢度 DE_MI_Fastness = 1
  //  色差-牢度-跳灯 DE_Fastness_MI = 2
  //  跳灯-色差-牢度 MI_DE_Fastness = 3
  //  跳灯-牢度-色差 MI_Fastness_DE = 4
  //  牢度-色差-跳灯 Fastness_DE_MI = 5
  //  牢度-跳灯-色差 Fastness_MI_DE = 6
  sortType: [
    { label: "智能排序", value: 0 },
    // 暂时注释
    // { label: "综合", value: 0 },
    // { label: "色差-跳灯-牢度", value: 1 },
    // { label: "色差-牢度-跳灯", value: 2 },
  ],
  // 单位
  unitList: ["%", "g/L"],
  // 'G/K', 'grm'
  loading: 0,
  showLoading: true,
  hasShowToast: false,
  toastMsg: "操作警告",
  icon: "warning",
  timer: null,
  guideStep: 0,
  websocketPath: "ws://127.0.0.1:1024",
  mainBgColor: "#ffffff",
  mainPadding: "30px",
  mainMargin: "20px",
  routerwhiteList: ["/403", "/login", "/appLogin", "/app-pdf", "/home"],
});
const methods = {
  //特殊页面main局部样式
  specialMainStyle() {
    data.mainBgColor = "#F8F9FC";
    data.mainPadding = "0";
    data.mainMargin = "20px";
  },
  //重置main局部样式
  resetMainStyle() {
    data.mainBgColor = "#ffffff";
    data.mainPadding = "30px";
    data.mainMargin = "20px";
  },
  showToast({ msg, type }) {
    ElMessage({
      message: msg || "serve error",
      type: type,
    });
  },
  error(msg) {
    methods.showToast({ msg, type: "error" });
  },
  success() {
    methods.showToast({ msg, type: "success" });
  },
  /**
   * @param {source 来源, 0: 普通配方, 1: 小样配方, 2: 复样配方}
   * @param {code 配方代号}
   * @param {fentryId 花色号}
   * @param {orderNo 打样编号/合约号}
   * @return: text: code || code + fentryId
   */
  hSource(source, code, fentryId, orderNo) {
    let text = "";
    switch (source) {
      case 0:
        text = code;
        break;
      case 1:
        text = orderNo + "-" + fentryId;
        break;
      case 2:
        text = orderNo + "-" + fentryId;
        break;

      default:
        text = code;
        break;
    }
    return text;
  },
  // 判断是否存在精明配色页面
  isColorCorrect() {
    const arr = Cookie.get("userMa").pages;
    return arr.includes('/correct')
  },

  // 设置表头缓存
  /**
   * @param {columnSelecteds<Array>: 需要缓存的列}
   * @return: undefined
   */
  hAfterLeave(columnSelecteds) {
    // console.log(columnSelecteds)
    localStorage.setItem("columnSelecteds", JSON.stringify(columnSelecteds));
  },

  // 菜单、按钮是否有权限
  authorityShow(api) {
    const role = Cookie.get("userMa").role;
    const arr = Cookie.get("userMa").btns;
    if (role.isAllAuthority) return true;
    else return arr.indexOf(api) !== -1;
  },
  // 按钮对应菜单是否有权限
  menusShow(path) {
    // const role = Cookie.get("userMa").role;
    const arr = Cookie.get("userMa").menus;
    if (!arr[0]) return;
    const role = Cookie.get("userMa").role;
    const routerArr = methods.fn(arr).map((item) => item.path);
    if (role.isAllAuthority) return true;
    else return routerArr.includes(path);
  },
  openMenusShow() {
    return new Promise((res, rej) => {
      // proxy.$post
      res("123");
    });
  },
  // 树形数据转平铺数据
  fn(source) {
    let res = [];
    source.forEach((el) => {
      res.push(el);
      el.children && res.push(...methods.fn(el.children));
    });
    return res;
  },

  // 浏览器是否可使用websocket
  isSupportWebSocket() {
    if (!"WebSocket" in window) {
      ElMessage.error("您的浏览器不支持WebSocket");
      return false;
    } else {
      return true;
    }
  },
  /**
   * WebSocket基础使用函数
   * @param {通信传参 0:连接 1:白校正 2:黑校正 3:取色 4:取色(v*100) 5:查询校正有效期时间 6:设置校正有效范围 7:温度湿度查询  8:设备状态查询(返回0正常)}
   * @callback {回调返回接收的消息}
   * @connectStatus {连接状态 0:连接尚未建立 1:已建立,可以进行通信 2:连接正在进行关闭 3:连接已经关闭或者连接不能打开}
   */
  useWebSocket(param, callback) {
    if (window.ws == undefined) {
      window.ws = new WebSocket(data.websocketPath);
    }
    //连接建立时触发 仅通信一次
    window.ws.onopen = function () {
      if (window.ws.readyState == 1) {
        window.ws.send("{ type: " + param + "}");
      }
    };
    //已建立连接 可以正常通信
    if (window.ws.readyState == 1) {
      window.ws.send("{ type: " + param + "}");
    }
    //接收消息
    window.ws.onmessage = function (e) {
      console.log("接收消息", JSON.parse(e.data));
      typeof callback === "function" && callback(JSON.parse(e.data));
    };
    //关闭连接
    window.ws.onclose = (e) => {
      globalStore.data.loading = 0;
      window.ws = undefined;
    };
  },
  /**
   * useTimerWebSocket WebSocket定时器使用函数
   * @param {通信传参 0:连接 1:白校正 2:黑校正 3:取色 4:取色(v*100) 5:查询校正有效期时间 6:设置校正有效范围 7:温度湿度查询  8:设备状态查询(返回0正常)}
   * @callback {回调返回接收的消息}
   * @connectStatus {连接状态 0:连接尚未建立 1:已建立,可以进行通信 2:连接正在进行关闭 3:连接已经关闭或者连接不能打开}
   */
  useTimerWebSocket(param, callback) {
    if (window.wsTimer == undefined) {
      try {
        window.wsTimer = new WebSocket(data.websocketPath);
      } catch (err) {
        console.log(err);
      }
    }
    //连接建立时触发 仅通信一次
    window.wsTimer.onopen = function () {
      if (window.wsTimer.readyState == 1) {
        window.wsTimer.send("{ type: " + param + "}");
      }
    };
    //已建立连接 可以正常通信
    if (window.wsTimer.readyState == 1) {
      window.wsTimer.send("{ type: " + param + "}");
    }
    //接收消息
    window.wsTimer.onmessage = function (e) {
      typeof callback === "function" && callback(JSON.parse(e.data));
    };
    //关闭连接
    window.wsTimer.onclose = (e) => {
      window.wsTimer = undefined;
    };
    //连接失败
    window.wsTimer.onerror = (err) => {
      // console.log(err)
      if (err.type === "error") {
        callback(err);
      }
    };
  },
  // WebSocket 连接 滴液机
  /**
   * @param {type}
   * @ip {地址}
   * @callback {回调函数}
   * @return:
   */
  WebSocketStillicide(params, callback, ip, port) {
    console.log(port);
    if (window.wss == undefined) {
      window.wss = new WebSocket("ws://" + "127.0.0.1:" + port);
    } else {
      window.wss.send(params);
    }
    let setID = setTimeout(() => {
      // ElMessage.error("请求超时");
      callback({
        IsSucceed: false,
        Message: "请求超时, 请检查ip地址是否正确",
      });
      globalStore.data.loading = 0;
      window.wss?.close();
      window.wss = undefined;
      console.log(1)
    }, 30000);
    window.wss.onopen = function () {
      window.wss.send(params);
    };
    window.wss.onmessage = function (e) {
      clearTimeout(setID);
      callback(JSON.parse(e.data));
      //window.wss.close();
    };
    window.wss.onclose = function () {
      clearTimeout(setID);
      window.wss = undefined;
      globalStore.data.loading = 0;
      console.log(3)
    };
    window.wss.onerror = async function (e) {
      // console.log(e);
      clearTimeout(setID);
      callback({
        IsSucceed: false,
        Message: "插件连接失败,请重新点击导出",
      });
      window.wss = undefined;
    };
  },

  /**
   * @param {[{type: 0:检查连接 4:根据名称搜索返回反射率, Parameter: ['关键字']  }]}
   * @callback {回调函数}
   * @return:
   */
  WebDCI(params, callback) {
    if (window.wsDci == undefined) {
      window.wsDci = new WebSocket("ws://127.0.0.1:10024");
    } else {
      window.wsDci.send(params);
    }
    let setIdDci = setTimeout(() => {
      callback({
        IsSucceed: false,
        Message: "请求超时",
      });
      globalStore.data.loading = 0;
      window.wsDci?.close();
      window.wsDci = undefined;
    }, 10000);
    window.wsDci.onopen = () => {
      window.wsDci.send(params);
    };
    window.wsDci.onmessage = function (e) {
      clearTimeout(setIdDci);
      callback(JSON.parse(e.data));
    };
    window.wsDci.onclose = function () {
      clearTimeout(setIdDci);
      window.wsDci = undefined;
      globalStore.data.loading = 0;
    };
    window.wsDci.onerror = async function (e) {
      // console.log(e);
      clearTimeout(setIdDci);
      callback({
        Succeed: false,
        Message: "插件连接失败, 请打开或安装插件",
        q: true, // 需要启动或安装插件
      });
      window.wsDci = undefined;
    };
  },
};
export default {
  data,
  ...toRefs(data),
  ...methods,
};
